/**
 *  @class
 *  @function ProductRecommendations
 *  Fetches its products from data-url: the cart drawer's recommendations,
 *  the product page's complementary products and the recommendations
 *  section. Without data-url (the cart drawer's product list, drawn by
 *  snippets/cart-drawer-upsell.liquid) there is nothing to fetch, and the
 *  panel, already in its full state, slides out of the open drawer.
 *
 *  The cart drawer's Add buttons (product-card-small's direct_add): one
 *  click adds the product through theme.cart, redraws the cart with focus on
 *  the new line, then reports the add. A refused add shows its message under
 *  the button.
 */
// Loaded by the layout (cart drawer) and by the product sections, so it can
// run more than once on a page.
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			this.addEventListener('click', this.onAddClick.bind(this));
		}
		fetchProducts() {
			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if ( this.parent ) {
							this.parent.classList.add('product-recommendations--full');

							if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
								this.parent.classList.add('active');
							}
						}

					}

					this.classList.add('product-recommendations--loaded');

				})
				.catch(e => {
					console.error(e);
				});
		}
		connectedCallback() {
			if (!this.dataset.url) {
				this.showPanel();
				return;
			}
			this.fetchProducts();
		}
		// A drawn panel that arrives with a redraw of the open drawer slides
		// out once it has been painted in place, as a fetched one does.
		showPanel() {
			const drawer = document.getElementById('Cart-Drawer');
			if (!this.parent || !this.parent.classList.contains('product-recommendations--full') || !drawer || !drawer.contains(this)) return;
			requestAnimationFrame(() => requestAnimationFrame(() => {
				if (this.isConnected && OverlayManager.isOpen(drawer) && !OverlayManager.closing.has(drawer)) {
					this.parent.classList.add('active');
				}
			}));
		}
		onAddClick(event) {
			const button = event.target.closest('.product-cart-item-add');
			if (!button || !this.contains(button)) return;
			event.preventDefault();
			if (button.getAttribute('aria-disabled') === 'true') return;

			const requested = [{
				id: parseInt(button.dataset.variantId, 10),
				quantity: parseInt(button.dataset.quantity, 10) || 1
			}];
			const error = button.parentElement.querySelector('.product-cart-item-error');
			const context = this.closest('#Cart-Drawer') ? 'dialog' : 'product';

			// Not disabled: the button keeps keyboard focus until the redraw.
			button.setAttribute('aria-disabled', 'true');
			button.classList.add('loading');
			if (error) error.hidden = true;

			theme.cart.add(requested)
				.then((state) => {
					const line = (state.items || [])[0];
					theme.cart.render(state, { focusKey: line && line.key });
					theme.cart.added(requested, state, context);
				}, (failure) => {
					if (!error) return;
					error.querySelector('small').textContent = (failure.body && failure.body.description) || theme.strings.cartError;
					error.hidden = false;
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					button.removeAttribute('aria-disabled');
					button.classList.remove('loading');
				});
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
